import dynamic from 'next/dynamic'

export const BackgroundImageSection = dynamic(
    () => import('./background-image-section'),
)
